// Shared by the build (static HTML, llms.txt, structured data) and the browser.

export const BRAND = 'luxurydice';
export const CONTACT = 'info@luxurydice.com';

export const METALS = {
  titanium: {
    name: 'Titanium', grade: 'Grade 5 (Ti-6Al-4V)', density: 4.43, hardness: '≈ 340 HV',
    base: '#B9BCC0', rough: 0.26, metal: 1, infill: '#16181C',
    sw: 'radial-gradient(circle at 35% 30%,#F4F5F7,#A9ADB3 50%,#5D6168)',
    feel: 'Light in the hand and cool grey. It will not tarnish.'
  },
  brass: {
    name: 'Brass', grade: 'Lead-free CW724R', density: 8.3, hardness: '≈ 160 HV',
    base: '#DDBB6E', rough: 0.22, metal: 1, infill: '#1A140C',
    sw: 'radial-gradient(circle at 35% 30%,#FFF1C2,#C9A24E 50%,#6E531E)',
    feel: 'Warm gold with real weight. Darkens to a soft patina as you play.'
  },
  bronze: {
    name: 'Bronze', grade: 'Phosphor bronze CuSn8', density: 8.8, hardness: '≈ 180 HV',
    base: '#C38E63', rough: 0.27, metal: 1, infill: '#170F0A',
    sw: 'radial-gradient(circle at 35% 30%,#F6D3B2,#A8703F 50%,#5A3519)',
    feel: 'Deep amber, dense and quiet when it lands.'
  },
  copper: {
    name: 'Copper', grade: 'Cu-ETP (C110), 99.9 %', density: 8.94, hardness: '≈ 90 HV',
    base: '#E6977A', rough: 0.24, metal: 1, infill: '#1A0D08',
    sw: 'radial-gradient(circle at 35% 30%,#FFD2BE,#C0694A 50%,#6A2C17)',
    feel: 'Rose-red when new. It browns gently with handling.'
  },
  steel: {
    name: 'Blackened steel', grade: '316L stainless, black oxide', density: 8.0, hardness: '≈ 200 HV',
    base: '#2B2D32', rough: 0.34, metal: 0.9, infill: '#D9D4C7',
    sw: 'radial-gradient(circle at 35% 30%,#9EA3AC,#3B3F46 50%,#111316)',
    feel: 'Near-black and very hard-wearing. Resists corrosion.'
  }
};

export const PIECES = {
  imperator: {
    name: 'The Imperator', type: 'd6', metal: 'titanium', volume: 4.0, sheet: 1,
    kind: 'Six-sided dice (d6)',
    desc: 'A cube with softly radiused edges and deep, enamel-filled pips. Opposite faces add up to seven, as on every proper d6.',
    specs: [['Size', '16 × 16 × 16 mm'], ['Edge radius', '1.0 mm'], ['Pips', 'Ø 3.2 mm, 0.8 mm deep']],
    dims: { w: '16.00 ±0.02', h: '16.00 ±0.02', c1: 'Edge radius R1.0', c2: 'Pip Ø3.2, 0.8 deep' }
  },
  aurelian: {
    name: 'The Aurelian', type: 'd10', labels: 'units', metal: 'brass', volume: 1.95, sheet: 2,
    kind: 'Ten-sided dice (d10), numbered 0–9',
    desc: 'Ten kite-shaped faces meeting at two points. The numbers are engraved deep enough to read by touch, and the 6 and 9 are underlined so they are never confused.',
    specs: [['Size', '22 mm point to point'], ['Width', '19.1 mm'], ['Numbers', '0 to 9, 0.5 mm deep']],
    dims: { w: '19.10', h: '22.00', c1: 'Numbers engraved 0.5 deep', c2: 'Enamel filled, polished back' }
  },
  nocturne: {
    name: 'The Nocturne', type: 'd10', labels: 'tens', metal: 'steel', volume: 1.95, sheet: 3,
    kind: 'Percentile dice (d10), numbered 00–90',
    desc: 'The tens partner to the Aurelian. Roll the two together and read them as one number from 1 to 100, for wild magic, loot tables and critical hits.',
    specs: [['Size', '22 mm point to point'], ['Width', '19.1 mm'], ['Numbers', '00 to 90, 0.5 mm deep']],
    dims: { w: '19.10', h: '22.00', c1: 'Numbers engraved 0.5 deep', c2: 'Enamel filled, polished back' }
  }
};

export const weightOf = (pid, m) => Math.round(PIECES[pid].volume * METALS[m].density) + ' g';

// Product image sizes rendered ahead of time (see scripts/render-images.html).
export const IMG_SIZES = [480, 960];
export const THUMB = 160;
export const imgKey = (pid, metal, size) => `${pid}-${metal}-${size}`;
